export enum DefaultCacheKey {
  SessionContainer = 'SessionContainer',
}
